// Lib
import { useEffect } from 'react';

// Utils
import { hideNativeLaunchScreen } from '../utils/nativeLaunchScreenUtils';

/**
 * Hides the native launch screen once `shouldHide` becomes true (defaults to on mount).
 *
 * Use this from any full-screen state the app can boot into that isn't the workspace or the
 * logged-out splash, so the user isn't left staring at a blank launch screen.
 */
const useHideNativeLaunchScreen = (shouldHide = true): void => {
    useEffect(() => {
        if (shouldHide) hideNativeLaunchScreen();
    }, [shouldHide]);
};

export default useHideNativeLaunchScreen;
